export default {
  styleOverrides: {
    paper: {
      '& > form': {
        display: 'contents',
      },
    },
  },
};
